import {ErrorHandler} from "@angular/core";
import {SettingsService} from "./shared/settings.service";
import * as Raven from 'raven-js';

export class RavenErrorHandler implements ErrorHandler {

    /**
     * Whether sentry error logger is already installed.
     */
    private installed = false;

    /**
     * RavenErrorHandler Constructor.
     */
    constructor(private settings: SettingsService) {}

    /**
     * Handle specified error.
     */
    public handleError(err:any) : void {
        console.error(err);

        if (this.installSentry()) {
            Raven.captureException(err.originalError || err);
        }
    }

    /**
     * Install sentry error logger.
     */
    private installSentry(): boolean {
        //already installed
        if (this.installed) return true;

        //no sentry public key is set
        if ( ! this.settings.has('logging.sentry_public')) return false;

        //install
        Raven.config(this.settings.get('logging.sentry_public')).install();
        return this.installed = true;
    }
}


// WEBPACK FOOTER //
// E:/wamp64/www/helpdesk/client/src/app/raven-error-handler.ts